/**
 * Normalizes autocomplete payloads into non-empty strings.
 * Accepts GAIA `{ text }` objects or plain strings; drops missing/malformed entries
 **/
export function parseAutoCompleteSuggestions(suggestions: unknown): string[] {
    if (!Array.isArray(suggestions)) return [];

    const texts: string[] = [];
    for (const suggestion of suggestions) {
        const text = suggestionText(suggestion);
        if (text !== undefined) texts.push(text);
    }
    return texts;
}

function suggestionText(suggestion: unknown): string | undefined {
    if (typeof suggestion === "string" && suggestion.length > 0) return suggestion;
    if (suggestion !== null && typeof suggestion === "object" && "text" in suggestion) {
        const { text } = suggestion as { text: unknown };
        if (typeof text === "string" && text.length > 0) return text;
    }
    return undefined;
}
